import BatteryWaste from './BatteryWaste';

export default BatteryWaste;
